/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { IOTestData } from './IOTestData';
const IOTestExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('io_test')],
    ['data', IOTestData],
]);
export class IOTestExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return IOTestExtraParser.decode(input).map(res => new IOTestExtra(res));
    }
    static unsafeDecode(input) {
        return IOTestExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestExtraParser.encode(data);
    }
    static schema() {
        return IOTestExtraParser.schema();
    }
}
